import styled from 'styled-components/macro';

export const UserInfoCard = styled.div`
  padding: 1.5rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 2rem;
  border: 1px solid #e5e5e5;
`;

export const UserInfoHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const UserAvatar = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: #6a93ca;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1.1rem;
`;

export const UserDetails = styled.div`
  flex: 1;
`;

export const UserName = styled.div`
  font-weight: 600;
  font-size: 1.1rem;
  color: #1a202c;
`;

export const UserEmail = styled.div`
  color: #4a5568;
  font-size: 0.9rem;
`;

export const UserRoleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const UserRoleBadge = styled.span`
  background-color: #6a93ca;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-weight: 500;
  font-size: 0.8rem;
`;

export const RoleRequirement = styled.div`
  color: #4a5568;
  font-size: 0.9rem;
`;

export const MessageAlert = styled.div<{ type: 'success' | 'error' }>`
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 6px;
  background-color: ${({ type }) => (type === 'success' ? '#D1FAE5' : '#FEE2E2')};
  color: ${({ type }) => (type === 'success' ? '#065F46' : '#991B1B')};
  border: 1px solid ${({ type }) => (type === 'success' ? '#D1FAE5' : '#FEE2E2')};
  font-size: 0.9rem;
`;

export const FormSection = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e5e5;
`;

export const SectionTitle = styled.h2`
  color: #1a202c;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e5e5e5;
`;

export const PresetButtonsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const PresetButton = styled.button<{ color: string }>`
  padding: 1rem;
  background-color: ${({ color }) => color};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
`;

export const FormLabel = styled.label`
  display: block;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #6a93ca;
    box-shadow: 0 0 0 3px rgba(106, 147, 202, 0.1);
  }
`;

export const FormSelect = styled.select`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 0.9rem;
  background-color: white;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #6a93ca;
    box-shadow: 0 0 0 3px rgba(106, 147, 202, 0.1);
  }
`;

export const HelpText = styled.small`
  color: #666;
  font-size: 0.8rem;
  margin-top: 0.5rem;
  display: block;
  line-height: 1.4;
`;

export const ManualDocumentsSection = styled.div`
  margin-bottom: 2rem;
  margin-top: 0.5rem;
`;

export const DocumentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  margin-bottom: 0.5rem;
`;

export const DocumentSelect = styled.select`
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 0.9rem;
`;

export const DocumentCheckbox = styled.input`
  margin-right: 0.5rem;
`;

export const RemoveButton = styled.button`
  background-color: #dc2626;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #b91c1c;
  }
`;

export const AddButton = styled.button`
  background-color: #059669;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #047857;
  }
`;

export const ActionButtonsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  align-items: center;
  margin-top: 2rem;
`;

export const SubmitButton = styled.button<{ disabled?: boolean }>`
  background-color: ${({ disabled }) => (disabled ? '#9ca3af' : '#6a93ca')};
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #5a82b8;
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

export const SecondaryButton = styled.button`
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e5e7eb;
    border-color: #9ca3af;
  }
`;

export const UsageNotesSection = styled.div`
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
`;

export const UsageTitle = styled.h3`
  color: #1a202c;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const UsageList = styled.ul`
  color: #4a5568;
  font-size: 0.9rem;
  line-height: 1.6;
  padding-left: 1.5rem;

  li {
    margin-bottom: 0.5rem;
  }
`;

export const PropertySearchContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`;

export const PropertySearchInput = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #6a93ca;
    box-shadow: 0 0 0 3px rgba(106, 147, 202, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const PropertyDropdownContainer = styled.div`
  position: relative;
  margin-top: 0.5rem;
`;

export const PropertyCount = styled.small`
  color: #6b7280;
  font-size: 0.8rem;
  margin-top: 0.25rem;
  display: block;
`;

export const AutocompleteContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const AutocompleteDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e5e5e5;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
`;

export const AutocompleteItem = styled.div<{ isHighlighted?: boolean }>`
  padding: 0.75rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  background-color: ${({ isHighlighted }) => (isHighlighted ? '#f3f4f6' : 'white')};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f3f4f6;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const PropertyId = styled.span`
  font-weight: 600;
  color: #1a202c;
  font-size: 0.9rem;
`;

export const PropertyName = styled.span`
  color: #6b7280;
  font-size: 0.8rem;
  margin-left: 0.5rem;
`;

// Modern Searchable Dropdown Styles
export const ModernSearchableDropdown = styled.div`
  position: relative;
  width: 100%;
`;

export const ModernDropdownButton = styled.div<{ isOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background: white;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 44px;

  &:hover {
    border-color: #6a93ca;
  }

  &:focus-within {
    outline: none;
    border-color: #6a93ca;
    box-shadow: 0 0 0 3px rgba(106, 147, 202, 0.1);
  }

  ${({ isOpen }) =>
    isOpen &&
    `
    border-color: #6a93ca;
    box-shadow: 0 0 0 3px rgba(106, 147, 202, 0.1);
  `}
`;

export const ModernDropdownInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.9rem;
  color: #1a202c;

  &::placeholder {
    color: #9ca3af;
  }
`;

export const ModernDropdownArrow = styled.div<{ isOpen?: boolean }>`
  width: 16px;
  height: 16px;
  margin-left: 0.5rem;
  transition: transform 0.2s ease;
  color: #6b7280;

  ${({ isOpen }) =>
    isOpen &&
    `
    transform: rotate(180deg);
  `}

  &::after {
    content: '▼';
    font-size: 12px;
  }
`;

export const ModernDropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ModernDropdownOption = styled.div<{ isHighlighted?: boolean; isSelected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  cursor: pointer;
  transition: all 0.15s ease;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f3f4f6;
  }

  ${({ isHighlighted }) =>
    isHighlighted &&
    `
    background: #f3f4f6;
  `}

  ${({ isSelected }) =>
    isSelected &&
    `
    background: #eff6ff;
    border-left: 3px solid #6a93ca;
  `}
`;

export const ModernOptionContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ModernOptionId = styled.span`
  font-weight: 600;
  color: #1a202c;
  font-size: 0.9rem;
`;

export const ModernOptionName = styled.span`
  color: #6b7280;
  font-size: 0.8rem;
  margin-top: 2px;
`;

export const ModernDropdownEmpty = styled.div`
  padding: 12px;
  text-align: center;
  color: #9ca3af;
  font-style: italic;
`;

export const IVEnabledIndicator = styled.span`
  color: #10b981;
  margin-left: 8px;
  font-size: 0.875rem;
`;

// Signal Scenario Result Styles
export const SignalResultCard = styled.div`
  margin-top: 20px;
  padding: 20px;
  background-color: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 8px;
`;

export const ResultHeader = styled.h4`
  margin: 0 0 16px 0;
  color: #166534;
  font-size: 16px;
`;

export const ResultSection = styled.div`
  margin-bottom: 12px;
`;

export const ResultLabel = styled.div`
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
  font-size: 14px;
`;

export const ResultCode = styled.code`
  display: block;
  padding: 8px 12px;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.5;
  color: #1f2937;
`;

export const ResultList = styled.ul`
  margin: 0;
  padding-left: 20px;
  font-size: 13px;
  color: #4b5563;

  li {
    margin-bottom: 4px;
  }
`;

// Tab Navigation Styles
export const TabContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #e5e5e5;
  margin-bottom: 2rem;
  gap: 0;
`;

export const Tab = styled.button<{ isActive: boolean }>`
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ isActive }) => (isActive ? '#6a93ca' : '#6b7280')};
  border-bottom: 3px solid ${({ isActive }) => (isActive ? '#6a93ca' : 'transparent')};
  margin-bottom: -2px;
  transition: all 0.2s ease;

  &:hover {
    color: #6a93ca;
    background-color: #f9fafb;
  }
`;

export const TabContent = styled.div`
  min-height: 400px;
`;

// Applicant Link Styles
export const ApplicantLinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

export const ApplicantLink = styled.a`
  display: inline-block;
  padding: 8px 16px;
  background-color: #6a93ca;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #5a82b8;
    color: white;
  }
`;

export const CopyLinkButton = styled.button`
  padding: 8px 12px;
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e5e7eb;
    border-color: #9ca3af;
  }
`;

export const CopySuccess = styled.span`
  color: #059669;
  font-size: 13px;
  font-weight: 500;
`;
